import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router';

import { PageNotFoundView } from 'targets/web/modules/dashboard/views';
import CustomerJobsPage from 'targets/customer-portal/modules/jobs/views/CustomerJobsPage';

import { jobsRoutes } from './routes';

const JobsRoutes: FC = () => (
  <Routes>
    <Route
      index
      element={<Navigate to={`${jobsRoutes.jobs}/${jobsRoutes.internalRoutes.active}`} />}
    />
    <Route
      path={jobsRoutes.internalRoutes.active}
      element={<CustomerJobsPage type="active-jobs" />}
    />
    <Route
      path={jobsRoutes.internalRoutes.completed}
      element={<CustomerJobsPage type="completed-jobs" />}
    />
    <Route path="*" element={<PageNotFoundView />} />
  </Routes>
);

export default JobsRoutes;
